module.exports = __webpack_public_path__ + "img/lh.5ee68083.png";